import React from "react"

import JSONLD from "./JSONLD"

import { AlgoliaProductHit } from "@secureo/common/typings/Algolia"

const ProductHitStructuredData = ({ product, locale }: Props) => {
	const { name, objectID, slug, grossPriceCents, image, manufacturer } = product

	const url = `${process.env.NEXT_PUBLIC_HOST}/${locale}/p/${slug}`

	const json = {
		"@context": "http://schema.org/",
		"@type": "Product",
		image,
		sku: objectID,
		name,
		brand: manufacturer,
		offers: {
			"@type": "Offer",
			priceCurrency: "EUR",
			price: String(grossPriceCents / 100),
			itemCondition: "http://schema.org/NewCondition",
			availability: "http://schema.org/InStock",
			seller: {
				"@type": "Organization",
				name: "Digitalzylinder Shop",
			},
			url,
		},
	}

	return <JSONLD json={json} metaKey={objectID} />
}

interface Props {
	product: AlgoliaProductHit
	locale: string
}

export default ProductHitStructuredData
